import React, { useState, useEffect,useCallback } from "react";
import {  Container, Col, Row, Button, Form} from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import { useDropzone } from "react-dropzone";
import 'react-toastify/dist/ReactToastify.css';
import LoaderBtn from "../components/LoaderBtn";
import { useNavigate } from 'react-router-dom'
import AllHeader from "../components/AllHeader";
import useCheckUser from "../custom-hooks/useCheckUser";
import useViewport from "../custom-hooks/useViewport ";

function Profile () {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [load, setLoad] =useState(false);
  const [image, setImage] = useState(null);
  const [imageSize, setImageSize] = useState(0);
  const [seenProfile, setSeenProfile] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const { width } = useViewport();

    // Example usage of the custom hook
    useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
      const axios = require("axios");    
      axios
        .post(apiUrl + "Load_Profile", {
          Uid: UserID,
        })
        .then((res) => {
          if (res.data.result === "true") { 
            setName(res.data.data.Firstname);
            setCode(res.data.data.CodeMelli);
            setMobile(res.data.data.Mobile);
            setImage(null);
            setImageSize(0);
          } 
        });
  }, []);

  const removeImage = () => {
    setImage(null);
    setImageSize(0);
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      setImageSize(Math.round(file.size / 1024));
      const reader = new FileReader();
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        if (file.size > 2000000) {
          toast.error("عکس نباید بیشتر از 2 مگابایت باشد", {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        } else {
          const img_src = reader.result;
          setImage(img_src);
        }
      };
      reader.readAsDataURL(file);
    });
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });


  const handleSubmit = (e) => {
    e.preventDefault();
     if (name === 0 || code === "" || mobile=== "" || image === "") {
      toast.error("لطفا اطلاعات را تکمیل کنید ", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    setLoad(true)
    const axios = require("axios");    
    axios
      .post(apiUrl + "Register_Profile", {
        FirstName: name,
        Codemelli: code,
        mobile: mobile,
        Profile: "",
        Id: UserID,
        Uid: UserID,
      })
      .then((res) => {
        if (res.data.result === "true") { 
          setLoad(false);
          localStorage.setItem("user_namefamily",name)
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          setLoad(true)
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  };

    //enter for input insted of click button submitHandler function
    const keyPress = (e) => {
      if (e.keyCode === 13) {
        handleSubmit(e)
      }
    }

  
    //Focus on the Next Field
    const handleEnter = (event) => {
      if (event.key.toLowerCase() === "enter") {
        const form = event.target.form;
        const index = [...form].indexOf(event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    };


  return (
    <div className="pt-5">
      <AllHeader>
      <span>پروفایل کاربر</span>
      </AllHeader>
      <Container>
        <Row className="justify-content-center">
          <Col xs={11} lg={7} className="rgc-title">
          
            <Form>
              <Row className="justify-content-center">
                <Col lg="10" className="mb-3">
                  <Form.Group>
                    <Form.Label> نام و نام خانوادگی:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="نام"
                      id="txtname"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyDown={handleEnter}
                    ></Form.Control>
                  </Form.Group>
                </Col>

          
                <Col lg="10" className="mb-3">
                  <Form.Group>
                    <Form.Label>کد ملی:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="کد ملی"
                      id="txtname"
                      type={width >820 ? "text":"number"}
                      value={code}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) => setCode(e.target.value)}
                      onKeyDown={handleEnter}
                    ></Form.Control>
                  </Form.Group>
                </Col>

                <Col lg="10" className="mb-3">
                  <Form.Group>
                    <Form.Label>شماره همراه:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="شماره همراه"
                      id="txtname"
                      type={width >820 ? "text":"number"}
                      value={mobile}
                        onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                      onChange={(e) => setMobile(e.target.value)}
                      onKeyDown={(event) => keyPress(event)}
                    ></Form.Control>
                  </Form.Group>
                </Col>
             
                {/* <Col className="text-center" lg="10">
                <label className="py-2">لطفا تصویر پروفایل خود را در این قسمت  وارد نمایید:</label>
                      {!image ? (
                          <div className="dropzone mt-0" id="myDropzone2">
                            <div {...getRootProps()}>
                              <input {...getInputProps()} multiple={true} />
                              <button className="dz-button" type="button">
                                انتخاب تصویر پروفایل
                              </button>
                            </div>
                          </div>
                       
                      ) : (
                      
                          <div
                            className="dropzone mt-0 drop-custom"
                            id="myDropzone2"
                          >
                            <div className="imgbox__container">
                              <img src={image} className="imgbox__img" alt="" />
                              <p
                                className="imgbox__size"
                                onClick={() => removeImage()}
                              >
                                {imageSize + " KB"}{" "}
                                <i className="fa fa-times-circle"></i>
                              </p>
                            </div>
                          </div>
                    
                      )}
                 </Col> */}

                        
                <Col xs="9" md="5"  className="text-center">
                  <Button
                    className="btn-fill rgc-btn"
                    type="submit"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                    <LoaderBtn loads={load} />
                    <span>ثبت</span>
                  </Button>
                </Col>

              </Row>
            </Form>
          </Col>
        </Row>
      </Container>

      <div className="rgc-toast">
      <ToastContainer
        autoClose={3000}
				/>
      </div>
      {/* <Loaders loads={load} /> */}
    </div>
  );
}

export default Profile;
